import React, {useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import {featureInterface} from "../../../../interfaces/featureInterface";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {ROUTES} from "../../../../routes";
import ShopFeatureOptionsCommon from "../shopFeatureOptionsCommon";
import {navFeatureCLick} from "../../lookNavigation/lookFunctions";
import {enableRelatedFeature} from "../../lookNavigation/lookFunctions2";
import WithUpdateLookCartItem from "../../hocs/withUpdateLookCartItem";
import {shopContextAction, useShopContext} from "../shopCategory/shopNavItemsContext";


const ShopFeatureOptions = (props) => {

  const {feature, history} = props;
  const [activeOption, setActiveOption] = useState(null);

  const {shopContextDispatch} = useShopContext();

  const optionsButtonClick = (option, updateLookCartItem) => {

    const featureLabel = Analytics.getSkuForAnalytics(option.feature);
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.shopFeatureOptions + featureLabel);

    shopContextDispatch(shopContextAction({shopActiveFeature: option.feature.dbFeature.sku || option.feature.dbFeature.sharedFeatureName}))

    setActiveOption(option);
    navFeatureCLick(option.feature);
    enableRelatedFeature(option.feature);
    updateLookCartItem(option.feature) // removed since we have select button on look journey

    history.push(`${ROUTES.shop}/${option.feature.partId}/${option.feature.dbFeature.sku || option.feature.dbFeature.sharedFeatureName}`);
  };

  return (
    <WithUpdateLookCartItem>
      {(updateLookCartItem) => {
        return (
          <ShopFeatureOptionsCommon feature={feature}
                                    optionsButtonClick={(option) => optionsButtonClick(option, updateLookCartItem)}
                                    withTitle={true}
                                    activeOption={activeOption}/>
        )
      }}
    </WithUpdateLookCartItem>
  )
};

ShopFeatureOptions.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired,
}

const mapStateToProps = () => {

  return {

  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopFeatureOptions)
)
